var _a, _a2, _a3, _a4, _a5, _a6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1061 810",
    xmlSpace: "preserve",
    className: "hero__svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _a || (_a = /*#__PURE__*/React.createElement("a", {
    href: "#novaScotia",
    "aria-label": "Jump to Nova Scotia"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Nova Scotia"), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "808,483.8 808.1,485.3 806.5,485.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "804.2,490.2 805,487.4 802.4,485.6 799.9,487.2 797.2,486.9 795.3,485.5 793.9,489 792.7,490.9  792.2,492 790.8,492.2 789.4,493.3 789.2,491.7 784.9,493.2 783.7,494.4 780,494.1 778.3,495.5 775.9,494.9 773.9,494.9  772.9,496.9 772.4,499.3 770.3,506.5 769.6,509.9 771.1,509.8 772,508.4 775.3,506.5 778.2,504.6 781.8,502.9 785.3,501.3  780.9,505.5 779.1,508.2 780.2,511.1 778.3,510.2 776.6,509.9 774.7,507.9 773.1,511.7 771,514.9 767.7,521.1 766.1,525.2  768,522.9 765.3,526.8 763.6,531.7 765.5,527.9 765,536.3 769.5,542.2 770.8,540.6 773.7,543.2 774.9,543.4 775.7,542.8  776.3,542.7 777,542.7 777.2,542.2 778.2,541.4 778,538.2 779.8,536.6 780.9,533.2 781.7,529.9 782,527.7 782.7,526.5 782.9,525  782.9,524.1 783.5,523.9 782.2,521.4 783,518.3 784.4,519.5 784.3,516.4 788.5,517.3 788.1,513.5 791.4,512.4 792.4,510.6  793.6,509.8 798.5,503.5 803.1,496.6 805.3,493.9 807.2,491 808.8,489.9 808.3,488.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "813.6,470.9 814,473.4 813.2,476.9 808,482.9 804.6,485.8 801.1,484.2 798.7,475.6 798.4,466.4  801,458.5 804.1,462.9 805.3,468.6 806.3,471.5 805.4,474.3 803,479.1 805,477.1 804.2,479.7 805.4,482.6 806.9,480.8 808.3,479.5  809.1,474.9 806.5,476.6 807.2,474.3 806.6,473.2 807.2,469.6 809.4,469.9  "
  })))), _a2 || (_a2 = /*#__PURE__*/React.createElement("a", {
    href: "#ontario",
    "aria-label": "Jump to Ontario"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Ontario"), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "665.1,555.5 643,565.2 632.3,559.9 613.4,557.3 596.4,542.4 583.4,480.5 545,452  533.9,416.3 504.1,417 464.2,400.5 463.7,400.8 411,477.2 414.4,530.9 421.7,547.3 481.6,554 494.4,534.6 514.9,535.1 526,547.1  536.7,547.4 550.3,568.3 590.4,569 609.6,586 606.4,590.9 590.7,590.8 590.4,616.7 581.7,643.1 626.1,614.8 623.2,609.2  614.8,611.4 619.8,600.7 650.2,584.5 663.9,563.9 672.6,560.3 672.1,559.2 "
  })))), _a3 || (_a3 = /*#__PURE__*/React.createElement("a", {
    href: "#britishColumbia",
    "aria-label": "Jump to British Columbia"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "British Columbia"), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "52.6,456 66.4,488.2 87.7,513.4 90.6,512.9 90.6,503.6 82.1,491.1 76.5,471.6 59.2,456.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "33.3,380.1 30.3,390.3 31,403.8 35.3,422.7 37.2,400.7 33.3,397.9 37.9,395.3 44.8,386.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "192.7,507.4 151.3,434.5 184.6,327.3 110.1,303.4 40.8,263.1 39,286.1 45.7,285.4 50.9,282.2  62,282.9 63.2,345.9 72.5,359.8 54.6,398.1 65.5,414.9 62.1,441.8 61.9,450.9 66.1,457.6 84.2,471.2 100.9,505.4 195.9,529.6  188.5,520.7  "
  })))), _a4 || (_a4 = /*#__PURE__*/React.createElement("a", {
    href: "#alberta",
    "aria-label": "Jump to Alberta"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Alberta"), /*#__PURE__*/React.createElement("polyline", {
    className: "svg__fill",
    points: "184.2,327.4 151,434.8 192.4,507.5 188.2,520.8 195.5,529.7 242.4,537.4 242.5,537.4  270.1,345 184.2,327.4 "
  })))), _a5 || (_a5 = /*#__PURE__*/React.createElement("a", {
    href: "#yukon",
    "aria-label": "Jump to Yukon"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Yukon"), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "151,317.2 151.3,300.3 132.3,295.8 136.5,284.3 125.7,270.3 132.3,244.2 132.3,228.6  124.3,211.9 134,198.7 124.3,194.5 135.6,179.7 123.7,174 140.5,143.2 131.4,124 126.2,119.5 29,249.6 41.2,258.9 40.8,263.9  110.1,304.1 110.1,304.1 "
  })))), _a6 || (_a6 = /*#__PURE__*/React.createElement("a", {
    href: "#quebec",
    "aria-label": "Jump to Quebec"
  }, /*#__PURE__*/React.createElement("g", {
    className: "hero__svg__province"
  }, /*#__PURE__*/React.createElement("title", null, "Quebec"), /*#__PURE__*/React.createElement("polygon", {
    className: "svg__fill",
    points: "729.5,397 723.8,392.1 727.2,387.5 717.4,381.3 723.1,407 702,409 699.8,398.2 676.8,384.9 674.9,359.8  689.8,363.6 709.3,357 703.4,341.5 689.8,333 680.5,310.6 663.6,297.2 650.7,275.3 650.7,275.3 654.8,298.1 647.7,314.7  626.7,311.5 609.3,280.1 593.7,284 586.4,277.5 567.1,269.9 563.1,277.6 537.5,279.6 536.6,287 544.3,294.4 543.7,308 556.5,323.2  552.9,344.5 574,357.8 582.7,376.5 580.9,394.5 564.5,416.3 588.1,453.1 583.9,479.8 583.8,479.7 596.8,541.7 613.7,556.6  632.7,559.1 643.4,564.4 665.5,554.7 673.8,559.2 701.9,547.7 710.9,497.3 721.9,494.5 717.2,484.6 721.2,477.9 730,477.9  734.1,473.6 747.8,467 750.4,450.8 736.5,449.8 711.6,477.4 702.1,505 693.8,517.4 695.5,512.9 707.1,467.9 715.8,453.3  714.7,437.8 765.9,413.6 777.5,403.3 781.4,380.3 788.1,366.7 784.1,361.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapD);
export default __webpack_public_path__ + "static/media/mapD.45e486bc69a6973c43c7f7134d19dcc4.svg";
export { ForwardRef as ReactComponent };